import React from 'react';
import { useTranslation } from 'react-i18next';
import { NumberInputWithUnit, Row, Section, Toggle } from '../settingsPrimitives';
import { usePreferencesStore } from '../../store/preferencesStore';
import { clampNotifySeconds } from './commandNotify';

/**
 * Settings → Extensions → Terminal → "Notifications" (Terminal board card 5):
 * a desktop notification when a command that ran at least N seconds
 * finishes while the window is in the background or its pane is hidden.
 * Works where the shell marks its prompts (OSC 133) — our own prompts and any
 * shell with shell integration.
 */
export default function TerminalNotifySetting() {
  const { t } = useTranslation();
  const on = usePreferencesStore((s) => s.terminalNotifyLongCommands !== false);
  const seconds = usePreferencesStore((s) => s.terminalNotifySeconds);
  const update = usePreferencesStore((s) => s.updatePreference);

  return (
    <Section title={t('terminalExt.notifySection', 'Notifications')}>
      <Row
        label={t('terminalExt.notifyLong', 'Notify when a long command finishes')}
        desc={t(
          'terminalExt.notifyLongDesc',
          'A desktop notification when the window is in the background or the terminal is hidden. Needs a shell that marks its prompts (shell integration).',
        )}
      >
        <Toggle value={on} onChange={(v) => update('terminalNotifyLongCommands', v)} />
      </Row>
      <Row label={t('terminalExt.notifyAfter', 'Only for commands longer than')}>
        <NumberInputWithUnit
          value={clampNotifySeconds(seconds)}
          min={3}
          max={3600}
          unit={t('terminalExt.seconds', 'seconds')}
          disabled={!on}
          onChange={(n) => update('terminalNotifySeconds', clampNotifySeconds(n))}
        />
      </Row>
    </Section>
  );
}
